import { render, staticRenderFns } from "./ViewTabs.vue?vue&type=template&id=c8239ac6&scoped=true&"
import script from "./ViewTabs.vue?vue&type=script&lang=js&"
export * from "./ViewTabs.vue?vue&type=script&lang=js&"
import style0 from "./ViewTabs.vue?vue&type=style&index=0&id=c8239ac6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8239ac6",
  null
  
)

export default component.exports